import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (
  { breakpoints }: Theme,
  overrideClasses?: CSSObject,
  onClick?: Function
) =>
  createStyles({
    container: {
      borderRadius: 'var(--borderRadius, 4px)',
      border: '1px solid #E9EAEC',
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      width: '100%',
      minHeight: 100,
      backgroundColor: palette.white,
      color: palette.white,
      overflow: 'hidden',
      position: 'relative',
      cursor: !onClick ? 'default' : 'pointer',
      '&>div': {
        position: 'relative',
        zIndex: 5,
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        width: 180,
        height: 180,
        borderRadius: '50%',
        zIndex: 1,
        top: -52,
        right: -141,
        [breakpoints.down('sm')]: {
          top: -105,
          right: -140,
        },
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        zIndex: 1,
        width: 180,
        height: 180,
        borderRadius: '50%',
        top: -125,
        right: -75,
        opacity: 0.5,
        [breakpoints.down('sm')]: {
          top: -155,
          right: -70,
        },
      },
      ...overrideClasses,
    },
    grayCircles: {
      '&:after': {
        background: `linear-gradient(85deg, ${palette.navSuperAdminActions} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      },
      '&:before': {
        background: `linear-gradient(83deg, ${palette.navSuperAdminActions} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      },
    },
    greenCircles: {
      '&:after': {
        background: `linear-gradient(85deg, ${palette.navAdmin} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      },
      '&:before': {
        background: `linear-gradient(83deg, ${palette.navAdmin} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      },
    },
    blueCircles: {
      '&:after': {
        background: `linear-gradient(85deg, ${palette.navOperator} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      },
      '&:before': {
        background: `linear-gradient(83deg, ${palette.navOperator} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      },
    },
    yellowCircles: {
      '&:after': {
        background: `linear-gradient(85deg, ${palette.deepBlue} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      },
      '&:before': {
        background: `linear-gradient(83deg, ${palette.deepBlue} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      },
    },
    noCircles: {
      borderRadius: 'var(--borderRadius, 4px)',
      border: `2px solid ${palette.deepBlue}`,
      background: '#FCFCFC',
      boxShadow: '0px 1px 30px 0px rgba(0, 0, 0, 0.05)',
      width: '100%',
      minHeight: 70,
      backgroundColor: palette.white,
      color: palette.white,
      overflow: 'hidden',
      position: 'relative',
      cursor: !onClick ? 'default' : 'pointer',
      '&>div': {
        position: 'relative',
        zIndex: 'auto',
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        visibility: 'hidden',
        width: 180,
        height: 180,
        borderRadius: '50%',
        zIndex: 1,
        top: -52,
        right: -141,
        [breakpoints.down('sm')]: {
          top: -105,
          right: -140,
        },
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        visibility: 'hidden',
        zIndex: 1,
        width: 180,
        height: 180,
        borderRadius: '50%',
        top: -125,
        right: -75,
        opacity: 0.5,
        [breakpoints.down('sm')]: {
          top: -155,
          right: -70,
        },
      },
    },
  });
